export default __webpack_public_path__ + "static/media/dashboardBtn.d65765f6.png";